/** Names of the session cookies shared by the storefront and the personal account. */
export const AUTH_COOKIES = {
    ACCESS: 'nlk_access_token',
    REFRESH: 'nlk_refresh_token',
} as const;

/** How long the session cookies live without a refresh: 30 days. */
export const AUTH_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;
